import { authorityConfig, penguinContractConfig } from '@/config'

const Getters = {
  getUserInfoFromState: (state) => {
    return state.userInfo
  },
  getUserListFromState: (state) => {
    return state.userList
  },
  getUserListForSelectBox: (state) => {
    const selectBoxList = state.userList
      .filter((user) => {
        return user.emailVerifiedAt ? true : false
      })
      .map((user) => {
        const lastname = user.lastName ? user.lastName : ''
        const firstname = user.firstName ? user.firstName : ''
        const name = lastname ? `${lastname} ${firstname}` : firstname
        return {
          value: user.id,
          label: name
        }
      })
    return selectBoxList
  },
  getProductExpiredDateAlertUnreadsFromState: (state) => {
    return state.productExpiredDateAlertUnreads
  },
  getUnreadNoticeCount: (state) => {
    return state.unreadNoticeCount
  },
  authority: (state) => {
    if (state.userInfo && state.userInfo.authorityId) {
      return {
        id: state.userInfo.authorityId,
        isAdmin:
          state.userInfo.authorityId ===
          authorityConfig.AUTHORITY_TYPE_ID.ADMIN,
        isUser:
          state.userInfo.authorityId === authorityConfig.AUTHORITY_TYPE_ID.USER,
        isPartTime:
          state.userInfo.authorityId ===
          authorityConfig.AUTHORITY_TYPE_ID.PART_TIME,
        isOutsideStaff:
          state.userInfo.authorityId ===
          authorityConfig.AUTHORITY_TYPE_ID.OUTSIDE_STAF,
        isFunction1: state.userInfo.organization.isFunction1 === 1,
        isNextengineCooperate:
          state.userInfo.organization.isNextengineCooperate === 1
      }
    }

    // 初期値
    return {
      id: null,
      isAdmin: false,
      isUser: false,
      isPartTime: false
    }
  },
  isSalonAccount: (state) => {
    let isSalonAccount = false
    if (
      state.userInfo &&
      state.userInfo.externalPenguinContract &&
      state.userInfo.externalPenguinContract.length > 0
    ) {
      for (let i = 0; i < state.userInfo.externalPenguinContract.length; i++) {
        if (
          state.userInfo.externalPenguinContract[i].contractType ===
          penguinContractConfig.PENGUIN_ACCOUNT_TYPE.MAKER
        ) {
          return false
        }
        if (
          state.userInfo.externalPenguinContract[i].contractType ===
          penguinContractConfig.PENGUIN_ACCOUNT_TYPE.SALON
        ) {
          isSalonAccount = true
        }
      }
    }

    return isSalonAccount
  },
  isMakerAccount: (state) => {
    if (state.userInfo && state.userInfo.externalPenguinContract) {
      for (let i = 0; i < state.userInfo.externalPenguinContract.length; i++) {
        if (
          state.userInfo.externalPenguinContract[i].contractType ===
          penguinContractConfig.PENGUIN_ACCOUNT_TYPE.MAKER
        ) {
          return true
        }
      }
    }

    return false
  }
}

export default Getters
